<template>
	<div class="footer">
		<div class="footer-box">
			<div class="footer-box-box left">
				<div class="footer-box-box-tit">{{$t('关于我们')}}</div>
				<div v-html="content" class="footer-box-box-txt"></div>
			</div>

			<div class="footer-box-box right">
				<!-- <img src="../../static/images/logo.png" alt=""> -->
				<img src="../../static/images/logo.png" alt="">
				<div class="right-txt">
					<div>© 2024-{{ currentYear }} all rights reserved {{$t('北京麒智非凡科技咨询有限公司')}}</div>
					<div class="pointer" @click="onICP">京ICP备2025125255号-1</div>
					<div v-if="serviceData.service_mobile">{{$t('客服电话')}}：{{serviceData.service_mobile}}</div>
					<div v-if="serviceData.service_email">{{$t('电子邮箱')}}：{{serviceData.service_email}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getToken } from '@/utils/auth'
	import { userInfo, getconf } from '@/api/user'
	export default {
		name: 'ShortcutBar',
		data() {
			return {
				app_logo: '',//logo
				serviceData: {},//客服内容
				content: '',//富文本的内容
				currentYear: new Date().getFullYear(),//当前年份
			}
		},
		created() {
			this.onGetconf()
		},
		computed: {

		},
		mounted() {

		},
		methods: {
			onICP() {
				window.open("https://beian.miit.gov.cn/#/Integrated/index");
			},
			onGetconf() {
				getconf({ module: 'contact' }).then(res => {
					if (res.code == 1) {
						let data = res.data;
						this.serviceData = res.data;
						// console.log(data)
					}
				})

				getconf({ module: 'system' }).then(res => {
					if (res.code == 1) {
						let data = res.data;
						this.content = data.aboutus;
					}
				})
			},
		}
	};
</script>

<style scoped lang="scss">
	.footer {
		width: 100%;
		padding: 30px 0;
		background-color: #000;
		display: flex;
		justify-content: center;
		color: #FFFFFF;
	}

	.footer-box {
		width: 100%;
		max-width: 1600px;
		display: flex;
		align-items: flex-start;
		padding: 0 var(--page-gutter);
		box-sizing: border-box;
		flex-direction: column;
		gap: 24px;

		@media (min-width: 768px) {
			flex-direction: row;
			align-items: center;
			gap: 0;
		}

		.footer-box-box {
			width: 100%;

			@media (min-width: 768px) {
				width: calc(50% - 10px);
			}

			.footer-box-box-tit {
				font-size: 14px;
				padding-bottom: 20px;
			}

			.footer-box-box-txt {
				font-size: 12px;
				color: #dddddd;
			}
		}

		.left {
			margin-right: 0;

			@media (min-width: 768px) {
				margin-right: 49px;
			}
		}

		.right {
			margin-left: 0;
			display: flex;
			flex-direction: column;
			align-items: flex-start;

			@media (min-width: 768px) {
				margin-left: 49px;
				flex-direction: row;
				align-items: center;
			}

			img {
				width: 120px;
				height: 64px;
				margin: 0 0 12px;

				@media (min-width: 768px) {
					margin: 0 12px 0 0;
				}
			}

			.right-txt {
				line-height: 2em;
				font-size: 14px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/footerBar.vue